import { render } from "./ThemeDropdown.vue?vue&type=template&id=12ba6a37"
import script from "./ThemeDropdown.vue?vue&type=script&lang=js"
export * from "./ThemeDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ThemeDropdown.vue"]])

export default __exports__